import ColumnContainer from './ColumnContainer';

export default ColumnContainer;
